let contentObj = {}

if (typeof window === 'object') {
  const initI18n = require('@/lang')
  const i18n = initI18n.getI18n()

  /* 路由 */
  const routes = [
    {
      path: '*',
      redirect: '/index'
    },
    {
      path: '/',
      name: 'Home',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      meta: {
        label: i18n.t('dataCenter')
      },
      component: () => import('@/views/dataCenter/dataCenter_v3')
    }
  ]
  contentObj = {
    routes
  }
}
const componentsContent = {
  dataCenter_v3: 'dataCenter_v3_dispatch',
  map_v3: 'map_v3_leaflet'
}
/* 组件样式 */
const componentsStyle = {}
const assetsUrl = 'src/assets/dispatch'

module.exports = {
  ...contentObj,
  assetsUrl,
  componentsContent,
  componentsStyle
}
